<template>
	<div class="policyInfos">
		<div class="policyInfos_header">
			<topHeader
				:leftSrc="leftSrc"
				:label="label"
				:textColor="textColor"
				:backgroundColor="backgroundColor"
			></topHeader>
		</div>
		<div class="policyInfos_title">
			<p>{{ article.Title }}</p>
		</div>
		<div class="policyInfos_time">
			<p>{{ article.Createdate | dataFilter }}</p>
		</div>
		<div class="policyInfos_content">
			<pre>{{ article.Summary }}</pre>
		</div>
		<div class="policyInfos_files" v-show="!!newFileName">
			<a :href="'http://120.194.216.88:89/UploadFiles/Article/' + newFileName"
				>附件：{{ FileName }}</a
			>
		</div>
	</div>
</template>

<script>
	import topHeader from "@/components/header.vue";
	export default {
		data() {
			return {
				label: "政策文件列表",
				backgroundColor: "#ffffff",
				textColor: "#333333",
				leftSrc: require("@/assets/ico@2x.png"),
				// info: "",
				// title: "",
				// time: ""
				article: {},
				newFileName: "",
				FileName: "",
			};
		},
		mounted() {
			this.init();
		},
		methods: {
			init() {
				// this.info = this.$route.query.policy.Summary;
				// this.title = this.$route.query.policy.Title;
				// this.time = this.$route.query.policy.Createdate;
				this.$axios({
					url: "api/GetArticleDetail/" + this.$route.query.Id,
					method: "get",
				})
					.then((res) => {
						this.article = res.data.article;
						this.newFileName = res.data.article.ArticleFile.NewFileName;
						this.FileName = res.data.article.ArticleFile.FileName;
					})
					.catch((err) => {
						console.info(err);
					});
			},
		},
		components: {
			topHeader,
		},
		filters: {
			dataFilter: function(value) {
				if (value) {
					let time = value.substring(value.indexOf("(") + 1, value.length - 2);
					let date = new Date(Number(time));
					let year = date.getFullYear();
					let month = date.getMonth() + 1;
					let day = date.getDate();
					return `${year}年${month < 10 ? "0" + month : month}月${day}日`;
				} else {
					return value;
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.policyInfos {
		width: 100%;
		height: 100%;
		min-height: 100vh;
		.policyInfos_header {
			width: 100%;
			height: auto;
		}
		.policyInfos_title {
			width: 100%;
			height: auto;
			padding: 0.8rem 1rem;
			p {
				width: 100%;
				font-size: 0.96rem;
				line-height: 1rem;
				text-align: left;
				color: #333333;
			}
		}
		.policyInfos_time {
			width: 100%;
			height: 1rem;
			padding: 0 1rem;
			p {
				width: 100%;
				line-height: 1rem;
				text-align: left;
				font-size: 0.75rem;
				color: #c7c7c7;
			}
		}

		.policyInfos_content {
			width: 100%;
			height: auto;
			padding: 0.5rem 1rem;
			pre {
				width: 100%;
				height: auto;
				word-break: break-all;
				text-align: left;
				white-space: pre-wrap;
				font-size: 0.8rem;
				color: #666666;
				line-height: 1.23rem;
				letter-spacing: 0.05rem;
			}
		}

		.policyInfos_files {
			width: 100%;
			height: auto;
			padding: 0.5rem 1rem;
			text-align: left;
			margin-bottom: 3rem;
			a {
				display: block;
				width: 100%;
				text-align: left;
				font-size: 0.8rem;
				line-height: 1.5rem;
				color: #1488cc;
				text-decoration: none;
				cursor: pointer;

				&:hover {
					color: #ff7979;
				}

				&:active {
					color: #1488cc;
				}
			}
		}
	}
</style>
